import React from 'react';
import './ideas.css';
import idea from '../../assets/img/ideas_min.png';
import idea_mov from '../../assets/img/ideas_mov.png';
import { useTranslation } from "react-i18next";


const Ideas = () => {
    const [t] = useTranslation("ideas_libertad");

    return (
        <div className='ideas-id'>
            <div class="contenedor escritorio">
                <div class="row1">
                    <div class="col1 fade-in-fwd">
                        {/* <p class="descrip_ide fade-in-fwd">
                            <span class="Titulo_d">
                                {(t('header.titulo_1'))}
                                <i class="itali">
                                    {(t('header.titulo_2'))}
                                </i>
                            </span><br></br><br className='br_mov'></br>
                            {(t('header.descripcion_1'))}
                            <b> {(t('header.compartir'))} </b>
                            {(t('header.descripcion_2'))}
                            <b> {(t('header.reflexion'))} </b> {(t('header.descripcion_3'))}</p> */}
                        <p class="descrip_ide fade-in-fwd Titulo_d" style={{margin: "25px 0 10px 0"}}>
                            {(t('header.titulo_1'))} <i className='text-ama-se' style={{color: "#DF9700"}}>{(t('header.titulo_2'))}</i>
                        </p>
                        <p class="descrip_ide fade-in-fwd">
                            {(t('header.descripcion_1'))}
                            <b> {(t('header.compartir'))} </b>
                            {(t('header.descripcion_2'))}
                            <b> {(t('header.reflexion'))} </b> {(t('header.descripcion_3'))}
                        </p>
                    </div>
                    <img src={idea} alt="Imagen ideas" class="imgG horizontal-gradient " />
                </div>
            </div>
            {/* <div class="espacio"></div> */}
            <div class=" movil">
                <div class="row1">
                    <div class="col1_mov fade-in-fwd">
                        <p class="titulo_ide_mov">{(t('header.titulo_1'))} <i class="itali"> {(t('header.titulo_2'))}</i></p>
                        <p class="descrip_ide_mov">{(t('header.descripcion_1'))}
                            <b> {(t('header.compartir'))} </b>
                            {(t('header.descripcion_2'))}
                            <b> {(t('header.reflexion'))} </b> {(t('header.descripcion_3'))}</p>
                        {/* </div> */}
                    </div>
                    <img src={idea_mov} alt="Imagen ideas" class="imgG_mov horizontal-gradient " />
                    {/* <img  alt="Imagen ideas" class=" imgG fondo con " /> */}
                    {/* <div class ="imgG  con "></div> */}
                </div>
            </div>
        </div>
    );
}

export default Ideas 